/*
 * Copyright (c) 2020. American Express Company
 */

import './firefox-shim';
import { Tooltip } from '@americanexpress/dls-react';
import $ from 'jquery';
import * as _ from 'lodash';
import * as React from 'react';
import { Component, ReactComponentElement } from 'react';

import LiteralsService from '../../services/literals/LiteralsService';
import UnitService from '../../services/unit.service';
import { LocalDate } from '@js-joda/core';
import { JaegerService } from '../../services/jaeger.service';
import UtilsService from '../../services/utils.service';

import Typography from '../../components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import AdjustExpensesImage, { ReactComponent as AdjustExpensesIcon } from './adjust-expenses.svg';
import BabyImage, { ReactComponent as BabyIcon } from './baby.svg';
import BackpackImage, { ReactComponent as BackpackIcon } from './backpack.svg';
import BriefcaseImage, { ReactComponent as BriefcaseIcon } from './briefcase.svg';
import CareForFamilyImage, { ReactComponent as CareForFamily } from './care-for-family.svg';
import CharityImage, { ReactComponent as CharityIcon } from './charity.svg';
import EiffelTowerImage, { ReactComponent as EiffelTowerIcon } from './eiffel-tower.svg';
import EndOfLifeImage, { ReactComponent as EndOfLifeIcon } from './end-of-life.svg';
import GraduationCapImage, { ReactComponent as GraduationCapIcon } from './graduation-cap.svg';
import LadderImage, { ReactComponent as LadderIcon } from './ladder.svg';
import LargePurchaseImage, { ReactComponent as LargePurchase } from './large-purchase.svg';
import MoneyBagImage, { ReactComponent as MoneyBagIcon } from './money-bag.svg';
import OilBarrelImage, { ReactComponent as OilBarrelIcon } from './oil-barrel.svg';
import PalmTreeImage, { ReactComponent as PalmTreeIcon } from './palm-tree.svg';
import PayDownDebtImage, { ReactComponent as PayDownDebtIcon } from './pay-down-debt.svg';
import PersonalItemsImage, { ReactComponent as PersonalItemsIcon } from './personal-items.svg';
import PigBankImage, { ReactComponent as PigBankIcon } from './piggy-bank.svg';
import ReduceExpensesImage, { ReactComponent as ReduceExpensesIcon } from './reduce-expenses.svg';
import RockingChairImage, { ReactComponent as RockingChairIcon } from './rocking-chair.svg';
import ShieldImage, { ReactComponent as ShieldIcon } from './shield.svg';
import SocialSecurityImage, { ReactComponent as SocialSecurityIcon } from './social-security.svg';
import SoldSignImage, { ReactComponent as SoldSignIcon } from './sold-sign.svg';
import StockBoomImage, { ReactComponent as StockBoomIcon } from './stock-boom.svg';
import StockCrashImage, { ReactComponent as StockCrashIcon } from './stock-crash.svg';
import WillImage, { ReactComponent as WillIcon } from './will.svg';

import AdjustExpensesSafari from './retina/adjust-expenses.png';
import BabySafari from './retina/grow-family.png';
import BackpackSafari from './retina/save-emergency-fund.png';
import BriefcaseSafari from './retina/new-job.png';
import CareForFamilySafari from './retina/care-for-family.png';
import CharitySafari from './retina/donate-income.png';
import EiffelTowerSafari from './retina/take-a-vacation.png';
import EndOfLifeSafari from './retina/end-of-life.png';
import GraduationCapSafari from './retina/plan-for-education.png';
import LadderSafari from './retina/get-a-promotion.png';
import LargePurchaseSafari from './retina/large-purchase.png';
import MoneyBagSafari from './retina/windfall.png';
import OilBarrelSafari from './retina/oil-shock.png';
/* eslint-disable import/no-duplicates */
import PalmTreeSafari from './retina/quit-job.png';
import PersonalItemsSafari from './retina/lose-job.png';
import PayDownDebtSafari from './retina/pay-down-debt.png';
import PigBankSafari from './retina/savings-goal.png';
import ReduceExpensesSafari from './retina/budget-expenses.png';
import RockingChairSafari from './retina/retire.png';
import ShieldSafari from './retina/life-insurance.png';
import SocialSecuritySafari from './retina/social-security.png';
import SoldSignSafari from './retina/buy-a-house.png';
import StockBoomSafari from './retina/stock-boom.png';
import StockCrashSafari from './retina/stock-crash.png';
import WillSafari from './retina/receive-inheritance.png';
/* eslint-enable import/no-duplicates */
import './Goal.scss';
import { css } from '@emotion/react';

export const goalTypes: any = {
    Moment: 'moment-goal bw-goal-type',
    'Savings Goal': 'savings-goal bw-goal-type',
    Scenario: 'scenario-goal bw-goal-type'
};

export const goalImages: { [key: string]: string } = {
    '2008 crash': StockCrashImage,
    '2010 boom': StockBoomImage,
    'adjust expenses': AdjustExpensesImage,
    'budget expenses': ReduceExpensesImage,
    'buy new home': SoldSignImage,
    'care for a family member': CareForFamilyImage,
    'child starts college': GraduationCapImage,
    'collect social security': SocialSecurityImage,
    'donate a portion of your income': CharityImage,
    'end of life': EndOfLifeImage,
    'estimate life insurance': ShieldImage,
    'get promoted': LadderImage,
    'have a baby': BabyImage,
    'lose job': PersonalItemsImage,
    'make a large purchase': LargePurchaseImage,
    'new job': BriefcaseImage,
    'oil shock': OilBarrelImage,
    'pay down debt': PayDownDebtImage,
    'plan for education costs': GraduationCapImage,
    'quit job': PalmTreeImage,
    'receive inheritance': WillImage,
    retire: RockingChairImage,
    'save emergency fund': BackpackImage,
    'save for baby': PigBankImage,
    'save for business': PigBankImage,
    'save for college': PigBankImage,
    'save for education costs': PigBankImage,
    'save for home': PigBankImage,
    'save for large purchase': PigBankImage,
    'save for retirement': PigBankImage,
    'save for vacation': PigBankImage,
    'save for wedding': PigBankImage,
    'take a vacation': EiffelTowerImage,
    windfall: MoneyBagImage
};

export const goalImagesSafari: { [key: string]: string } = {
    '2008 crash': StockCrashSafari,
    '2010 boom': StockBoomSafari,
    'adjust expenses': AdjustExpensesSafari,
    'budget expenses': ReduceExpensesSafari,
    'buy new home': SoldSignSafari,
    'care for a family member': CareForFamilySafari,
    'child starts college': GraduationCapSafari,
    'collect social security': SocialSecuritySafari,
    'donate a portion of your income': CharitySafari,
    'end of life': EndOfLifeSafari,
    'estimate life insurance': ShieldSafari,
    'get promoted': LadderSafari,
    'have a baby': BabySafari,
    'lose job': PersonalItemsSafari,
    'make a large purchase': LargePurchaseSafari,
    'new job': BriefcaseSafari,
    'oil shock': OilBarrelSafari,
    'pay down debt': PayDownDebtSafari,
    'plan for education costs': GraduationCapSafari,
    'quit job': PalmTreeSafari,
    'receive inheritance': WillSafari,
    retire: RockingChairSafari,
    'save emergency fund': BackpackSafari,
    'save for baby': PigBankSafari,
    'save for business': PigBankSafari,
    'save for college': PigBankSafari,
    'save for education costs': PigBankSafari,
    'save for home': PigBankSafari,
    'save for large purchase': PigBankSafari,
    'save for retirement': PigBankSafari,
    'save for vacation': PigBankSafari,
    'save for wedding': PigBankSafari,
    'take a vacation': EiffelTowerSafari,
    windfall: MoneyBagSafari
};

export const goalIcons: { [key: string]: JSX.Element } = {
    '2008 crash': <StockCrashIcon className="2008-crash-icon bw-goal-icon" />,
    '2010 boom': <StockBoomIcon className="2010-boom-icon bw-goal-icon" />,
    'adjust expenses': <AdjustExpensesIcon className="adjust-expenses-icon bw-goal-icon" />,
    'budget expenses': <ReduceExpensesIcon className="reduce-expenses-icon bw-goal-icon" />,
    'buy new home': <SoldSignIcon className="home-icon bw-goal-icon" />,
    'care for a family member': <CareForFamily className="care-for-a-family-member-icon bw-goal-icon" />,
    'child starts college': <GraduationCapIcon className="child-college-icon bw-goal-icon" />,
    'collect social security': <SocialSecurityIcon className="dollar-icon bw-goal-icon" />,
    'donate a portion of your income': <CharityIcon className="charity-icon bw-goal-icon" />,
    'end of life': <EndOfLifeIcon className="end-of-life-icon bw-goal-icon" />,
    'estimate life insurance': <ShieldIcon className="home-icon bw-goal-icon" />,
    'get promoted': <LadderIcon className="ladder-icon bw-goal-icon" />,
    'have a baby': <BabyIcon className="baby-icon bw-goal-icon" />,
    'lose job': <PersonalItemsIcon className="lose-job-icon bw-goal-icon" />,
    'make a large purchase': <LargePurchase className="purchase-icon bw-goal-icon" />,
    'new job': <BriefcaseIcon className="new-job-icon bw-goal-icon" />,
    'oil shock': <OilBarrelIcon className="oil-shock-icon bw-goal-icon" />,
    'pay down debt': <PayDownDebtIcon className="pay-down-debt-icon bw-goal-icon" />,
    'plan for education costs': <GraduationCapIcon className="plan-education-icon bw-goal-icon" />,
    'quit job': <PalmTreeIcon className="quit-job-icon bw-goal-icon" />,
    'receive inheritance': <WillIcon className="receive-inheritance-icon bw-goal-icon" />,
    retire: <RockingChairIcon className="retirement-icon bw-goal-icon" />,
    'save emergency fund': <BackpackIcon className="emergency-fund-icon bw-goal-icon" />,
    'save for baby': <PigBankIcon className="save-baby-icon bw-goal-icon" />,
    'save for business': <PigBankIcon className="save-business-icon bw-goal-icon" />,
    'save for college': <PigBankIcon className="save-college-icon bw-goal-icon" />,
    'save for education costs': <PigBankIcon className="save-education-icon bw-goal-icon" />,
    'save for home': <PigBankIcon className="save-house-icon bw-goal-icon" />,
    'save for large purchase': <PigBankIcon className="save-purchase-icon bw-goal-icon" />,
    'save for retirement': <PigBankIcon className="save-retirement-icon bw-goal-icon" />,
    'save for vacation': <PigBankIcon className="save-trip-icon bw-goal-icon" />,
    'save for wedding': <PigBankIcon className="save-wedding-icon bw-goal-icon" />,
    'take a vacation': <EiffelTowerIcon className="save-trip-icon bw-goal-icon" />,
    windfall: <MoneyBagIcon className="windfall-icon bw-goal-icon" />
};

export const savingGoalIcons: { [key: string]: JSX.Element } = {
    'save for baby': <BabyIcon className="save-baby-icon bw-goal-icon" />,
    'save for business': <GraduationCapIcon className="save-business-icon bw-goal-icon" />,
    'save for college': <GraduationCapIcon className="save-college-icon bw-goal-icon" />,
    'save for education costs': <GraduationCapIcon className="save-education-icon bw-goal-icon" />,
    'save for home': <SoldSignIcon className="save-house-icon bw-goal-icon" />,
    'save for large purchase': <LargePurchase className="save-purchase-icon bw-goal-icon" />,
    'save for retirement': <PigBankIcon className="save-retirement-icon bw-goal-icon" />,
    'save for vacation': <EiffelTowerIcon className="save-trip-icon bw-goal-icon" />
};

export const goalPlans: { [key: string]: string } = {
    '2008 crash': 'planning for a crash like 2008',
    '2010 boom': 'planning for a boom like 2010',
    'adjust expenses': 'planning how to reduce their expenses',
    'budget expenses': 'planning how to manage their expenses',
    'buy new home': 'planning to buy a new home',
    'care for a family member': 'planning to care for a family member',
    'child starts college': 'planning for their kids education',
    'collect social security': 'planning for social security',
    'donate a portion of your income': 'planning for charitable giving',
    'end of life': 'planning for their estate',
    'estimate life insurance': 'investigating life insurance',
    'get promoted': 'planning for a promotion',
    'have a baby': 'planning for a baby',
    'lose job': 'planning to lose a job',
    'make a large purchase': 'planning for a large purchase',
    'new job': 'planning to take a new job',
    'oil shock': 'planning for crash in oil stocks',
    'pay down debt': 'planning to pad down debt',
    'plan for education costs': 'planning for education',
    'quit job': 'planning to quit their job',
    'receive inheritance': 'planning to receive an inheritance',
    retire: 'planning for retirement',
    'save emergency fund': 'saving an emergency fund',
    'save for baby': 'saving for a child',
    'save for college': 'saving for college',
    'save for education costs': 'saving for education',
    'save for home': 'saving for a home',
    'save for large purchase': 'saving for a large purchase',
    'save for retirement': 'saving for retirement',
    'save for vacation': 'saving for a vacation',
    'save for wedding': 'saving for a wedding',
    'take a vacation': 'planning for a vacation',
    windfall: 'planning to receive a windfall'
};

export const GOAL_DRAG_OFFSET_X = 5;
export const GOAL_DRAG_OFFSET_Y = 40;

export default class Goal extends Component<any> {
    private handle: Element;
    private initialOffset: number = 0;
    private onDrag: any;
    private dragObject: Element;
    private dragDateArea: JQuery;
    private dragDateTop: JQuery;
    private dragDateBottom: JQuery;

    public override state = {
        cardStyle: {} as Object
    };

    public override componentDidMount(): void {
        this.onDrag = _.debounce((e: any) => {
            const posX: number = e.pageX - UnitService.getDrawerWidth() - this.props.context.offset;
            // don't show the date when we can't actually drop
            if (posX > 0) {
                const date: LocalDate = UnitService.getJaegarDateFromPixels(this.props.context, this.props.user, posX);
                const dateText: string = date && JaegerService.formatDates(this.props.user.dob, date);
                this.dragDateBottom.text(dateText);
                this.dragDateArea.offset({ top: e.pageY - 15, left: (e.pageX as number) + 40 });
                this.dragDateArea.show();
            } else {
                this.dragDateArea.hide();
            }
        }, 1);
    }

    public override render(): ReactComponentElement<any> {
        if (this.props.inDrawer) {
            return this.drawerRender();
        }
    }

    public drawerRender(): ReactComponentElement<any> {
        // if goalName starts with a number, it's not a legal class name, stick a 'g' at the start
        // eg. 'g2008 Crash'
        const goalName =
            this.props.goalData && /^\d/.test(this.props.goalData.name)
                ? `g${this.props.goalData.name}`
                : this.props.goalData.name;
        let classNames = `bw-drawer-goal ${this.props.cardData ? `bw-goal-${this.props.cardData.id}` : ''} ${
            this.props.goalData
                ? goalName.replace(/\s+/g, '-').toLowerCase()
                : this.props.cardData.description.replace(/\s+/g, '-').toLowerCase()
        }-goal`;

        if (this.props.selected) {
            classNames += ' selected';
        }

        if (this.props.disabled) {
            classNames += ' off';
        }

        const key: string = _.get(this.props, 'goalData.key');
        const description: string = LiteralsService.getLiteral('GoalsDrawer.' + key);
        const name: string = (
            _.get(this.props, 'goalData.name') || _.get(this.props, 'cardData.description')
        ).toLowerCase();
        const displayName: string = LiteralsService.getLiteral('Goals.' + name);

        const timelineVisible: boolean = $('.canvasContainer').width() > 1;
        if (timelineVisible) {
            classNames += ' draggable';
        }

        return (
            // eslint-disable-next-line no-return-assign
            !this.props.disabled ? (
                <button
                    ref={(c) => (this.handle = c)}
                    className={classNames}
                    draggable={timelineVisible}
                    onDragEnter={(e) => e.preventDefault()}
                    onDragStart={(e) => this.onDragStart(e, name)}
                    data-id={this.props.goalData ? this.props.goalData.id : this.props.cardData.id}
                    onDrag={(e) => {
                        e.persist();
                        if (this.onDrag) this.onDrag(e);
                    }}
                    onDragEnd={(e) => this.onDragEnd(e)}
                    style={{ ...this.state.cardStyle, textAlign: 'left' }}
                    onClick={(e) => {
                        void this.handleClick(e, name);
                    }}
                >
                    <div
                        className="iconContainer"
                        onDoubleClick={(e) => {
                            void this.handleDoubleClick(e);
                        }}
                        onClick={(e) => {
                            void this.handleClick(e, name);
                        }}
                    >
                        {
                            goalIcons[
                                this.props.goalData
                                    ? this.props.goalData.name.toLowerCase()
                                    : this.props.cardData.description.toLowerCase()
                            ]
                        }
                    </div>
                    <div className="goal-inner" key="goal-inner">
                        <Typography
                            onDoubleClick={async (e) => await this.handleDoubleClick(e)}
                            onClick={async (e) => await this.handleClick(e, name)}
                            className="bw-goal-name"
                            key="bw-goal-name"
                            variant={TypographyVariants.BODY}
                        >
                            {_.get(this.props, 'cardData.nickname') || displayName}
                        </Typography>
                        <Typography
                            onDoubleClick={async (e) => await this.handleDoubleClick(e)}
                            onClick={async (e) => await this.handleClick(e, name)}
                            className="bw-goal-description"
                            key="bw-goal-description"
                            variant={TypographyVariants.CAPTION}
                        >
                            {description}
                        </Typography>
                    </div>
                </button>
            ) : (
                <Tooltip
                    id="bw-goal-tooltip"
                    placement="top"
                    forcePlacement
                    theme={css`
                        display: inline-block;
                        position: relative;
                    `}
                    triggerElement={
                        <button className={classNames} style={this.state.cardStyle} aria-disabled>
                            <div className="iconContainer">
                                {
                                    goalIcons[
                                        this.props.goalData
                                            ? this.props.goalData.name.toLowerCase()
                                            : this.props.cardData.description.toLowerCase()
                                    ]
                                }
                            </div>
                            <div className="goal-inner" key="goal-inner">
                                <Typography
                                    className="bw-goal-name"
                                    key="bw-goal-name"
                                    variant={TypographyVariants.BODY}
                                >
                                    {_.get(this.props, 'cardData.nickname') || displayName}
                                </Typography>
                                <Typography
                                    className="bw-goal-description"
                                    key="bw-goal-description"
                                    variant={TypographyVariants.CAPTION}
                                >
                                    {_.get(this.props, 'goalData.description') || description}
                                </Typography>
                            </div>
                        </button>
                    }
                >
                    {this.props.tooltip ||
                        (this.props.onlySelected
                            ? `You can only have one 
                            ${this.props.goalData.name} goal.`
                            : 'You cannot use this goal at this time.')}
                </Tooltip>
            )
        );
    }

    private onDragEnd(event: any): void {
        document.body.style.cursor = '';
        const $event = $(event.target);
        document.body.removeChild(this.dragObject);
        this.dragDateArea.remove();

        $event.css('opacity', '1');
    }

    private async handleDoubleClick(event: any): Promise<void> {
        await this.props.handleDoubleClick(event);
    }

    private async handleClick(event: any, description: string): Promise<void> {
        if (this.props.handleClick) {
            await this.props.handleClick(event, description);
        } else {
            if (this.props.cardData) {
                this.props.handleOpenCard(this.props.cardData);
            }
        }
    }

    private onDragStart(event: any, description?: string): void {
        const $event = $(event.target);
        this.initialOffset = 40; // half the width of the dragObject
        this.dragObject = event.target.cloneNode(true);
        document.body.style.cursor = 'move';

        this.dragObject.classList.remove('bw-drawer-goal');
        this.dragObject.classList.add('jaeger-drag');
        document.body.appendChild(this.dragObject);

        const cursorOffset: number = UtilsService.getDragCursorOffset(this.dragObject);
        event.dataTransfer.setDragImage(this.dragObject, cursorOffset, cursorOffset);
        $event.css('opacity', '0');
        $('.bw-interpolation-overlay').css('background', 'black');
        const goalId = $event.attr('data-id');
        const name: string = description || $event.find('p').text().toLowerCase();
        event.dataTransfer.setData(
            'text',
            JSON.stringify({
                offsetX: 0,
                description: name,
                id: goalId,
                type: 'goal'
            })
        );

        // drag date area
        const dragDateArea: Element = document.createElement('div');
        const dragDateTop: Element = document.createElement('div');
        const dragDateBottom: Element = document.createElement('div');
        dragDateArea.classList.add('dragDateArea');
        dragDateTop.classList.add('dragDateTop');
        dragDateBottom.classList.add('dragDateBottom');
        dragDateArea.appendChild(dragDateTop);
        dragDateArea.appendChild(dragDateBottom);
        document.body.appendChild(dragDateArea);
        this.dragDateArea = $('.dragDateArea');
        this.dragDateTop = $('.dragDateTop');
        this.dragDateBottom = $('.dragDateBottom');
        this.dragDateTop.text(name);
    }
}
